define('shared/util/dom/expression/TextSearcher',[],function () {
    'use strict';

    var REGEX_SEARCH = /\$\{([\s\S]*?)\}/g;

    function normalize(node) {
        if (!node) {
            return;
        }
        if (node.nodeType == 3) {
            while (node.nextSibling && node.nextSibling.nodeType == 3) {
                node.nodeValue += node.nextSibling.nodeValue;
                node.parentNode.removeChild(node.nextSibling);
            }
        } else {
            normalize(node.firstChild);
        }
        normalize(node.nextSibling);
    }

    function Ctor( $el ){
        this.$el = $el;
        this.nodes = [];
    }

    var p = Ctor.prototype;
    p.search = function () {
        var node = this.$el[0];
        var cur;
        var ret = [];
        var match;
        var nodeInfo;

        normalize(node);
        cur = node.firstChild;

        if ( cur == null ) {
            return ret;
        }

        this.nodes = ret;

        // Loop over all childNodes.
        do {

            // Only process text nodes.
            if ( cur.nodeType !== 3 ) {
                continue;
            }

            if ( cur.nodeValue.search(REGEX_SEARCH) < 0 ) {
                continue;
            }

            REGEX_SEARCH.lastIndex = 0;

            nodeInfo =  {
                node: cur,
                keys: []
            };

            while( match = REGEX_SEARCH.exec( cur.nodeValue) ) {
                if ( match.length < 2 ) {
                    continue;
                }
                nodeInfo.keys.push( match[1] );
            }

            ret.push(nodeInfo);

        } while ( cur = cur.nextSibling );

        return ret;
    };

    return Ctor;
});
